"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./skills.scss");
var SkillBar2_1 = require("./components/SkillBar2/SkillBar2");
var SkillsBar_1 = require("./components/SkillBar/SkillsBar");
var Skills = /** @class */ (function (_super) {
    __extends(Skills, _super);
    function Skills() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Skills.prototype.render = function () {
        return (react_1.default.createElement("div", { className: 'skills-container' },
            react_1.default.createElement("div", { className: 'skill-bg-container' },
                react_1.default.createElement("div", { className: 'skill-bg-img' }),
                react_1.default.createElement("div", { className: 'skills-content-container' },
                    react_1.default.createElement("div", { className: 'f-skills' },
                        react_1.default.createElement("div", { className: 'f-title' },
                            react_1.default.createElement("h1", null, "Frontend")),
                        react_1.default.createElement("div", { className: 'f-skill-flex' },
                            react_1.default.createElement("div", { className: 'computer-front-icon', "data-aos": "zoom-out" }),
                            react_1.default.createElement("div", { className: 'f-skill-chart-container' },
                                react_1.default.createElement(SkillBar2_1.SkillBar2, null)))),
                    react_1.default.createElement("div", { className: 'b-skills' },
                        react_1.default.createElement("div", { className: 'b-title' },
                            react_1.default.createElement("h1", null, "Backend")),
                        react_1.default.createElement("div", { className: 'skill-b-flex' },
                            react_1.default.createElement("div", { className: 'b-computer-front-icon', "data-aos": "zoom-out" }),
                            react_1.default.createElement("div", { className: 'b-skill-chart-container' },
                                react_1.default.createElement(SkillsBar_1.SkillsBar, null))))))));
    };
    return Skills;
}(react_1.Component));
exports.Skills = Skills;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Skills/Skills.tsx
// module id = 68
// module chunks = 0